import React, {Component} from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

class ImpactDialog extends Component {
  render() {
    const {open, onClose, onConfirm, loading, usage, itemName, itemType} = this.props;
    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth data-testid="lc-impact-dialog">
        <DialogTitle>{`Delete ${itemType}`}</DialogTitle>
        <DialogContent dividers>
          {loading ? (
            <div style={{display: 'flex', alignItems: 'center', gap: 12, padding: '8px 0'}}>
              <CircularProgress size={20} />
              <Typography variant="body2">Checking usage…</Typography>
            </div>
          ) : usage ? (
            <>
              {usage.nodeCount > 0 || usage.diagramCount > 0 ? (
                <>
                  <Typography variant="body2" gutterBottom>
                    {`"${itemName}" is used by ${usage.nodeCount} node(s) across ${usage.diagramCount} diagram(s):`}
                  </Typography>
                  {Array.isArray(usage.diagrams) && usage.diagrams.length > 0 ? (
                    <List dense disablePadding>
                      {usage.diagrams.map((d) => (
                        <ListItem key={d.id} disableGutters>
                          <ListItemText primary={d.name} />
                        </ListItem>
                      ))}
                    </List>
                  ) : null}
                  <Typography variant="body2" style={{marginTop: 8}}>
                    Deleting it will mark those references as (inactive).
                  </Typography>
                </>
              ) : (
                <Typography variant="body2">Not used by any diagram.</Typography>
              )}
            </>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} data-testid="lc-impact-cancel-btn">Cancel</Button>
          <Button
            onClick={onConfirm}
            color="secondary"
            disabled={loading}
            data-testid="lc-impact-confirm-btn"
          >
            Delete anyway
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default ImpactDialog;
